import { Box, Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import type { WizardStepProps } from 'modules/engagement_surveys/components/SurveyWizard/types'

export function EditorsStep({ data, errors, onDataChanged }: WizardStepProps) {
  // Get initial IDs from selection state for edit forms
  const initialIds = data.editorSelection.type === 'manual' ? data.editorSelection.ids : undefined

  return (
    <Box gap="s32" gapDivider>
      <Box gap="s24">
        <Text.Header2 weight="semibold">
          {i18n.t('surveys.configuration.editors.title')}
        </Text.Header2>

        <EmployeeSelectorV2
          multiple
          label={i18n.t('surveys.configuration.editors.label')}
          value={initialIds}
          forcedFilters={{ excludeCurrentEmployee: true }}
          onChange={(selection) => {
            onDataChanged({ ...data, editorSelection: selection })
          }}
          error={
            typeof errors.editorSelection === 'string'
              ? errors.editorSelection
              : errors.editorSelection && 'ids' in errors.editorSelection
                ? String(errors.editorSelection.ids)
                : undefined
          }
        />
      </Box>

      <Box gap="s24">
        <Text.Header2 weight="semibold">
          {i18n.t('surveys.configuration.visibility.title')}
        </Text.Header2>

        <Card>
          <Card.Title
            size="small"
            action={
              <TogglerCheckbox
                onChange={() =>
                  onDataChanged({
                    ...data,
                    restrictedViewersEnabled: !data.restrictedViewersEnabled,
                  })
                }
                value={data.restrictedViewersEnabled}
              />
            }
          >
            {i18n.t('surveys.configuration.visibility.restricted_viewers.label')}
          </Card.Title>
          <Card.Description>
            {i18n.t('surveys.configuration.visibility.restricted_viewers.description')}
          </Card.Description>
        </Card>
      </Box>
    </Box>
  )
}
